import { render, staticRenderFns } from "./RoomObject.vue?vue&type=template&id=8980d81c&scoped=true"
import script from "./RoomObject.vue?vue&type=script&lang=js"
export * from "./RoomObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8980d81c",
  null
  
)

export default component.exports